import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { useSelector } from "react-redux";
import NotificationItem from "../../components/Header/NotificationDropdown/Item";
import "./index.scss";
const NotificationList = () => {
  const history = useHistory();
  const role = useSelector((state) => state?.user?.user?.role);

  const tempItem = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  return (
    <>
      <div className="page-wrapper">
        <div className="page-header">
          <h2 className="d-flex align-items-center">Notifications</h2>
        </div>
        <div className="inner-wrapper">
          <Row>
            {tempItem.map((item, index) => (
              <Col lg="3">
                <NotificationItem key={index} className="md-item" />
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </>
  );
};
export default NotificationList;
